require("!!/Users/gedarufi/Documents/Inger/Amorel/back.amorel/node_modules/script-loader/addScript.js")(require("!!/Users/gedarufi/Documents/Inger/Amorel/back.amorel/node_modules/raw-loader/index.js!/Users/gedarufi/Documents/Inger/Amorel/back.amorel/node_modules/bootstrap/js/dropdown.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/bootstrap/js/dropdown.js
// module id = 740
// module chunks = 15